class PushCartAccordion extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['trigger', 'panel']
  }

  static get styles () {
    return `
      :host {
        display: block;

        overflow: hidden;
      }
    `
  }

  connectedCallback () {
    super.connectedCallback()

    this._panelState = true
  }

  setupListeners () {
    super.setupListeners()

    this.onTriggerClick = this.onTriggerClick.bind(this)

    this.listeners.add(this.els.trigger.element, 'click', this.onTriggerClick)
  }

  onTriggerClick () {
    if (this._panelState) {
      this._panelState = false
      this.setAttribute('open', '')
    } else {
      this._panelState = true
      this.removeAttribute('open')
    }
  }
}

if (!customElements.get('push-cart-accordion')) {
  customElements.define('push-cart-accordion', PushCartAccordion)
}
